<template>
  <form class="form">
    <FormInput :label="$t('form.label.title')" v-model="form.fields.title" name="title" required/>
    <FormInput :label="$t('form.label.url')" type="url" v-model="form.fields.url" name="url"
               :message="$t('form.messages.url')" required/>
    <FormFile :label="$t('form.label.icon')" v-model="form.fields.icon" :name="`icon${index}`" accept=".png,.svg"
              :maxSize="500" required :message="$t('form.messages.500_ko_png_svg')" preview/>
  </form>
</template>

<script>
import {FormFile, FormInput} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'RapidLinks',
  mixins: [FormValidMixin],
  components: {
    FormFile,
    FormInput
  },
  props: {
    action: {
      type: Object,
      default: null
    },
    id: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        fields: {
          title: {
            value: null,
            valid: false
          },
          url: {
            value: null,
            valid: false
          },
          icon: {
            file: '',
            previewName: null,
            previewUrl: null,
            value: '',
            valid: false
          },
        },
        submitted: false
      },
    }
  },
  methods: {
    async submit() {
      if (this.form.valid) {
        this.form.submitted = true

        const formData = {
          title: this.form.fields.title.value,
          url: this.form.fields.url.value
        }

        let currentId
        this.id
            ? currentId = await this.$action.update(this.id, formData)
            : currentId = await this.$action.store(formData)

        if (this.form.fields.icon.file) {
          await this.$action.uploadIcon(currentId, this.form.fields.icon.file[0])
        }

        this.form.submitted = false
      }
    }
  },
  mounted() {
    if (this.action) {
      this.form.fields.title = {valid: this.action.title ? true : false, value: this.action.title}
      this.form.fields.url = {valid: this.action.url ? true : false, value: this.action.url}

      this.form.fields.icon.valid = this.action.icon ? true : false
      if (this.action.icon) {
        this.form.fields.icon.previewName = this.action.icon.name
        this.form.fields.icon.previewUrl = this.action.icon.url
      }
    }
  }
}
</script>